import { create } from "zustand";

export type VisitedRoute = {
    href: string;      // "/path?x=1#hash"
    pathname: string;  // "/path"
    ts: number;
};

type State = {
    items: VisitedRoute[];
    max: number;
    exclude: (href: string, pathname: string) => boolean;
    push: (route: Omit<VisitedRoute, "ts">) => void;
    clear: () => void;
    setMax: (max: number) => void;
};

export const useVisitedRoutesStore = create<State>((set, get) => ({
    items: [],
    max: 20,

    // tweak this for login/callback/noise routes
    exclude: (_href, pathname) =>
        pathname.startsWith("/auth") ||
        pathname.startsWith("/login") ||
        pathname.startsWith("/callback"),

    push: (route) => {
        const { items, max, exclude } = get();
        if (exclude(route.href, route.pathname)) return;

        // ignore consecutive dupes
        if (items[0]?.href === route.href) return;

        const next = [{ ...route, ts: Date.now() }, ...items];

        // de-dupe anywhere (keep most recent)
        const seen = new Set<string>();
        const deduped = next.filter((x) =>
        seen.has(x.href) ? false : (seen.add(x.href), true)
        );

        set({ items: deduped.slice(0, max) });
    },

    clear: () => set({ items: [] }),
    setMax: (max) => set({ max, items: get().items.slice(0, max) }),
}));
